<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
<!--
    <notifications></notifications>
-->

    <side-bar v-if="hasProfile">

     <!-- <sidebar-link to="/dashboard">
        <md-icon>home</md-icon>
        <p>Dashboard</p>
      </sidebar-link>-->
     <!--<sidebar-link to="/profile">
        <md-icon>perm_identity</md-icon>
        <p>Profile</p>
      </sidebar-link>-->
      <div class="customNavstyle" @click="userProfile">
        <i class="fa fa-user-circle"></i>
        <p>Profile</p>
      </div>
      <!--<sidebar-link to="/be-a-donor" v-if="beADonor">
        <md-icon>face</md-icon>
        <p>Be A Donor</p>
      </sidebar-link>-->
      <div class="customNavstyle" v-if="beADonor" @click="becomeDonor">
        <i class="fa fa-tint"></i>
        <p>Be A Donor</p>
      </div>
      <!--<sidebar-link to="/my-donation" v-if="myDonation">
        <md-icon>record_voice_over</md-icon>
        <p>My Donation</p>
      </sidebar-link>-->
      <div class="customNavstyle" v-if="myDonation" @click="myDonationList">
        <i class="fa fa-heart"></i>
        <p>My Donation</p>
      </div>
      <!--<sidebar-link to="/search-donor">
        <md-icon>location_on</md-icon>
        <p>Search A Donor</p>
      </sidebar-link>-->
      <div class="customNavstyle" @click="searchDonor">
        <i class="fa fa-search"></i>
        <p>Search A Donor</p>
      </div>
      <!--<sidebar-link to="/requests-feed">
        <md-icon>content_paste</md-icon>
        <p>Requests Feed</p>
      </sidebar-link>-->
      <div class="customNavstyle" @click="requestFeed">
        <i class="fa fa-users"></i>
        <p>Requests Feed</p>
      </div>

      <div v-if="data">
        <!--<sidebar-link to="/donor-list">
          <md-icon>contacts</md-icon>
          <p>Donors List</p>
        </sidebar-link>-->
        <div class="customNavstyle" @click="allDonorsList">
          <i class="fa fa-list"></i>
          <p>Donors List</p>
        </div>
        <!--<sidebar-link to="/finder-list">
          <md-icon>group</md-icon>
          <p>Finders List</p>
        </sidebar-link>-->
        <div class="customNavstyle" @click="allFindersList">
          <i class="fa fa-list-alt"></i>
          <p>Finders List</p>
        </div>
        <!--<sidebar-link to="/requests-list">
          <md-icon>grid_on</md-icon>
          <p>Requests List</p>
        </sidebar-link>-->
        <div class="customNavstyle" @click="allRequestsList">
          <i class="fa fa-comments"></i>
          <p>Requests List</p>
        </div>

        <div class="customNavstyle" @click="allFeedBackList">
          <i class="fa fa-comments"></i>
          <p>Feedback</p>
        </div>
      </div>
     <!-- <sidebar-link to="/maps">
        <md-icon>location_on</md-icon>
        <p>Maps</p>
      </sidebar-link>-->
      <!--<div class="customNavstyle" @click="maps">
        <i class="fa fa-globe"></i>
        <p>Maps</p>
      </div>-->
      <div class="customNavstyle" @click="logOut">
        <i class="fa fa-sign-out-alt"></i>
        <p>Log Out</p>
      </div>

     <!-- <mobile-menu ></mobile-menu>-->

    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content>

      </dashboard-content>
    </div>
  </div>
</template>
<style>
  .md-list.md-theme-default .md-selected .md-list-item-content, .md-list.md-theme-default .router-link-exact-active .md-list-item-content{
    color: #73cb00 !important;
  }
  .sidebar .nav p, .off-canvas-sidebar .nav p{
    font-weight: 400 !important;
  }
</style>
<script>
import TopNavbar from './TopNavbar.vue'
import DashboardContent from './Content.vue'
//import MobileMenu from '@/pages/Layout/MobileMenu.vue'

export default {
  components: {
    TopNavbar,
    DashboardContent,
    //MobileMenu
  },
  data (){
    return {
      data : false,
      hasProfile : false,
      beADonor: true,
      myDonation: false
    };
  },
  beforeMount(){
    let getData = this.$store.getters.getDataFromDashboardLayout;

        if (localStorage.getItem('user-response') != null) {
          let localdata = JSON.parse(localStorage.getItem('user-response'));
          if (localdata.data.user_profile === null) {
            this.$router.push({name: 'User Profile'});
          }
          else if (localdata.data.user_role.id === 1 && localdata.data.user_profile != null) {
            this.data = true;
            this.hasProfile = true;
            if (localdata.data.donor_profile != null){
              this.beADonor = false;
              this.myDonation =true
            }
          }
          else if (localdata.data.user_role.id != 1 && localdata.data.user_profile != null) {
            this.hasProfile = true;
            this.data = false;
            if (localdata.data.donor_profile != null){
              this.beADonor = false;
              this.myDonation =true
            }
          }
          this.$store.commit('setDataFromDashboardLayout', {data: this.data, hasProfile: this.hasProfile})
      }
    },
  methods:{
    userProfile(){
      this.$router.push({name: 'Profile'});
    },
    becomeDonor(){
      this.$router.push({name: 'Be A Donor'});
    },
    myDonationList(){
      this.$router.push({name: 'My Donation'});
    },
    searchDonor(){
      this.$router.push({name: 'Search Donors'});
    },
    requestFeed(){
      this.$router.push({name: 'Requests Feed'});
    },
    allDonorsList(){
      this.$router.push({name: 'Donor List'});
    },
    allFindersList(){
      this.$router.push({name: 'Finder List'});
    },
    allRequestsList(){
      this.$router.push({name: 'Requests List'});
    },
    allFeedBackList(){
      this.$router.push({name: 'FeedBack'});
    },
   /* maps(){
      this.$router.push({name: 'Maps'});
    },*/
    logOut(){
      window.localStorage.clear()
      this.$router.push('/')
    }
  }
}
</script>
<style scoped>
  .customNavstyle{
    margin: 0 auto;
    padding-left: 40px;
    cursor: pointer;
    margin-bottom: 4%;
    width: 100%;
  }
  .customNavstyle:hover{
    background-color: rgba(18, 200, 0, 0.2);
  }
  .customNavstyle p{
    color: #ffffff !important;
  }
  .customNavstyle i{
    color: #ffffff !important;
  }

  .sidebar .nav i{
    font-size: 15px !important;
  }
</style>
